import React from 'react';
import { Flex } from 'rebass';
import NavButton from 'components/NavButton';
import { RECRUITER, EMPLOYER } from 'constants/index';

const AdminNavigation: React.FC<any> = ({
  userRoleType,
  recruiterRoleTypeHandler,
  employerRoleTypeHandler,
}): JSX.Element => {
  return (
    <Flex width="50%" justifyContent="space-between" mt={5}>
      <NavButton
        title="Recruiters"
        active={userRoleType === RECRUITER}
        clickHandler={recruiterRoleTypeHandler}
      />
      <NavButton
        title="Employers"
        active={userRoleType === EMPLOYER}
        clickHandler={employerRoleTypeHandler}
      />
    </Flex>
  );
};

export default AdminNavigation;
